module.exports = __webpack_public_path__ + "img/img_assistant_phone_img3.764031fb.png";